import React from "react"
import {
  Box,
  Grid,
  Container,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
} from "@material-ui/core"
import { useStaticQuery, graphql, navigate } from "gatsby"
import { Link } from "gatsby-theme-material-ui"
import BackgroundImage from "gatsby-background-image"

const queryString = require("query-string")

const Comp = () => {
  let theme = useTheme()
  const smaller = useMediaQuery(theme.breakpoints.down("xs"))

  const data = useStaticQuery(graphql`
    query LifestyleQuery {
      desktop: file(
        relativePath: { eq: "home/Custo_Lifestyle_tv1_desktop.jpg" }
      ) {
        childImageSharp {
          fluid(quality: 100, maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      intro: file(relativePath: { eq: "home/intro.png" }) {
        childImageSharp {
          fluid(quality: 100, maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      mobile: file(
        relativePath: { eq: "home/Custo_Lifestyle_tv1_mobile.jpg" }
      ) {
        childImageSharp {
          fluid(quality: 100, maxWidth: 800) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      categories: allHasura {
        category {
          id
          name
          product_room_categories {
            id
            product {
              id
              slug
              style {
                id
                name
              }
              presets {
                id
                size
              }
            }
          }
        }
      }
    }
  `)

  return (
    <Box>
      {/* <Container maxWidth="lg"> */}
      <Grid container spacing={4} direction="row" alignItems="center">
        <Grid item xs={12} sm={6}>
          <Box py={8} textAlign={smaller ? "center" : "left"}>
            <Container maxWidth="xs">
              <Typography variant="h3" component="h2" gutterBottom>
                Custo Lifestyle
              </Typography>
              <Typography
                variant="body1"
                color="textSecondary"
                paragraph
                gutterBottom
              >
                Custo’s online tool empowers you to design furniture that fits
                your space, lifestyle and budget.
              </Typography>
              <Button
                variant="contained"
                color="secondary"
                size="large"
                component={Link}
                onClick={() =>
                  navigate(
                    queryString.stringifyUrl(
                      {
                        url: "/shop",
                        query: {
                          categories: data.categories.category.map(c =>
                            c.name.toLowerCase()
                          ),
                          styles: ["air", "cube", "stacc"],
                        },
                      },
                      { arrayFormat: "bracket" }
                    )
                  )
                }
                style={{ color: "white" }}
              >
                Create Your Design
              </Button>
            </Container>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} alignItems="center">
          <BackgroundImage
            fluid={[
              data.intro.childImageSharp.fluid,
              {
                ...data.intro.childImageSharp.fluid,
                media: `(min-width: 600px)`,
              },
            ]}
          >
            <Box height="100%" minHeight={600} />
          </BackgroundImage>
        </Grid>
      </Grid>
      {/* </Container> */}
    </Box>
  )
}

export default Comp
